import React from 'react';
import { Button, Grid, Paper, TextField, Typography } from '@mui/material';
// import { useHistory } from 'react-router-dom';  
import { Link } from 'react-router-dom';


const ForgetPassword: React.FC = () => {
    const paperStyle: React.CSSProperties = {
        padding: 50,
        height: 'auto',
        width: 500,
        margin: "50px auto"
    };
    // const handleResetPassword = () => {
    //      Navigate to the reset password page
    //     history.push('/login/Resetpassword');
    // };


    return (
        <Grid container justifyContent="center">
            <Paper elevation={10} style={paperStyle}>
                <Grid container direction="column" alignItems="center" spacing={2}>
                    <Grid item>
                        <Typography variant="h5">Forget your password</Typography>
                    </Grid>
                    <Grid item>
                        <Typography variant="h6">Enter your Username</Typography>
                    </Grid>
                    <Grid item>
                        <TextField label="Email" placeholder="Enter Username" variant='outlined' fullWidth />
                    </Grid>
                    <Grid item>
                    <Typography>
    <Link to='/login/Resetpassword'>Reset password?</Link>
  </Typography>
                    </Grid>
                    <Grid item>
                        <Typography variant="h6">I already have an OTP</Typography>
                    </Grid>
                </Grid>
            </Paper>
        </Grid>
    );
}

export default ForgetPassword;
